(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCountdown(el) {
    if (el._cdtInitialized) return;
    el._cdtInitialized = true;

    const endDate = el.dataset.endDate;
    const endTime = el.dataset.endTime || '23:59';
    const timezone = el.dataset.timezone || 'UTC';
    const expiredAction = el.dataset.expiredAction || 'message';

    if (!endDate) return;
    const parts = endDate.split('/');
    if (parts.length !== 3) return;
    const [month, day, year] = parts;
    const timeParts = endTime.split(':');
    const hour = timeParts[0] || '23';
    const minute = timeParts[1] || '59';

    const timezoneOffsets = {
      'PST': -8, 'PDT': -7,
      'MST': -7, 'MDT': -6,
      'CST': -6, 'CDT': -5,
      'EST': -5, 'EDT': -4,
      'UTC':  0, 'GMT':  0,
      'AMT':  4
    };

    const offset = timezoneOffsets[timezone.toUpperCase()] ?? 0;

    const utcMs = Date.UTC(
      parseInt(year, 10),
      parseInt(month, 10) - 1,
      parseInt(day, 10),
      parseInt(hour, 10),
      parseInt(minute, 10),
      0
    );
    const targetDate = new Date(utcMs - (offset * 3600000));

    if (isNaN(targetDate.getTime())) return;

    const daysEl    = el.querySelector('[data-days]');
    const hoursEl   = el.querySelector('[data-hours]');
    const minutesEl = el.querySelector('[data-minutes]');
    const secondsEl = el.querySelector('[data-seconds]');
    const expiredEl = el.querySelector('.countdown-timer-block__expired');
    const timerEl   = el.querySelector('.countdown-timer-block__timer');

    function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

    function flipAnimate(elem, newVal) {
      if (elem && elem.textContent !== newVal) {
        elem.classList.add('flip');
        setTimeout(() => { elem.textContent = newVal; elem.classList.remove('flip'); }, 150);
      }
    }

    let interval;

    function tick() {
      const diff = targetDate - new Date();
      if (diff <= 0) {
        clearInterval(interval);
        if (expiredAction === 'hide') {
          el.style.display = 'none';
        } else {
          if (timerEl) timerEl.style.display = 'none';
          if (expiredEl) {
            expiredEl.style.display = 'block';
            expiredEl.textContent = el.dataset.expiredMessage || 'This offer has ended.';
          }
        }
        return;
      }
      const totalSeconds = Math.floor(diff / 1000);
      const days    = Math.floor(totalSeconds / 86400);
      const hours   = daysEl ? Math.floor((totalSeconds % 86400) / 3600) : Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      if (daysEl) flipAnimate(daysEl, pad(days));
      flipAnimate(hoursEl,   pad(hours));
      flipAnimate(minutesEl, pad(minutes));
      flipAnimate(secondsEl, pad(seconds));
    }

    tick();
    interval = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('.countdown-timer-block').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:block:load', function (e) {
    const block = e.target.closest('.countdown-timer-block');
    if (block) initCountdown(block);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["signup-sign-up"] && !Shopify.designMode) return;
  try {
    const SIGNUP_ACCESS_COOKIE = 'signup_access';
  const SIGNUP_SUBSCRIBED_COOKIE = 'signup_subscribed';
  const SIGNUP_SUBSCRIBED_EMAIL_COOKIE = 'signup_subscribed_email';
  const SIGNUP_ACCESS_TTL_DAYS = 14;
  const SIGNUP_SUBSCRIBED_TTL_DAYS = 90;
  const SIGNUP_DIALOG_CLOSE_TIMEOUT_MS = 1000;

  function signupSetCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; SameSite=Lax${secure}`;
  }

  function signupGetCookie(name) {
    const prefix = `${name}=`;
    const cookies = document.cookie.split('; ');

    for (const cookie of cookies) {
      if (cookie.startsWith(prefix)) return decodeURIComponent(cookie.slice(prefix.length));
    }

    return null;
  }

  class SignupEarlyAccess extends HTMLElement {
    connectedCallback() {
      this.handleKlaviyoForm = this.handleKlaviyoForm.bind(this);
      window.addEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.captureVipAccess();
      this.syncActiveForm();
      this.render();
      this.watchKlaviyoForm();
    }

    disconnectedCallback() {
      window.removeEventListener('klaviyoForms', this.handleKlaviyoForm);
      this.formObserver?.disconnect();
      clearTimeout(this.successTimer);
    }

    readConfig() {
      const early = {};
      const returning = {};
      const valid = {};
      const forms = {};

      this.querySelectorAll('[data-signup-vip]').forEach((node) => {
        const code = (node.dataset.code || '').trim();
        if (!code) return;

        const formId = (node.dataset.formId || '').trim();
        const access = node.dataset.access === 'returning' ? 'returning' : 'early_bird';

        valid[code] = true;
        if (access === 'returning') returning[code] = true;
        else early[code] = true;
        if (formId) forms[code] = formId;
      });

      return {
        param: (this.dataset.vipParam || 'vip').trim() || 'vip',
        fallbackCode: (this.dataset.fallbackCode || '').trim(),
        early,
        returning,
        valid,
        forms,
      };
    }

    getAccess() {
      return signupGetCookie(SIGNUP_ACCESS_COOKIE);
    }

    isSubscribed() {
      return signupGetCookie(SIGNUP_SUBSCRIBED_COOKIE) === '1';
    }

    captureVipAccess() {
      const config = this.readConfig();

      try {
        const url = new URL(window.location.href);
        const vip = url.searchParams.get(config.param);

        if (!vip || !config.valid[vip]) return false;

        signupSetCookie(SIGNUP_ACCESS_COOKIE, vip, SIGNUP_ACCESS_TTL_DAYS);
        url.searchParams.delete(config.param);

        const query = url.searchParams.toString();
        const cleanUrl = url.pathname + (query ? `?${query}` : '') + url.hash;
        window.history.replaceState(window.history.state, '', cleanUrl);
        return true;
      } catch (error) {
        return false;
      }
    }

    markSubscribed(email) {
      const config = this.readConfig();
      const currentAccess = this.getAccess();

      signupSetCookie(SIGNUP_SUBSCRIBED_COOKIE, '1', SIGNUP_SUBSCRIBED_TTL_DAYS);

      if (!config.early[currentAccess] && !config.returning[currentAccess]) {
        if (config.fallbackCode) {
          signupSetCookie(SIGNUP_ACCESS_COOKIE, config.fallbackCode, SIGNUP_ACCESS_TTL_DAYS);
        }
      } else if (config.early[currentAccess]) {
        signupSetCookie(SIGNUP_ACCESS_COOKIE, currentAccess, SIGNUP_ACCESS_TTL_DAYS);
      }

      if (email) signupSetCookie(SIGNUP_SUBSCRIBED_EMAIL_COOKIE, email, SIGNUP_SUBSCRIBED_TTL_DAYS);
    }

    canPurchase(phase) {
      const config = this.readConfig();
      const access = this.getAccess();
      const subscribed = this.isSubscribed();

      if (phase === 'public') return true;
      if (phase === 'returning') return (config.early[access] && subscribed) || !!config.returning[access];
      if (phase === 'earlybird') return !!(config.early[access] && subscribed);

      return false;
    }

    getSignupFormKey() {
      const config = this.readConfig();
      const access = this.getAccess();

      if (access && config.forms[access]) return access;

      return 'default';
    }

    getActiveSlot() {
      const formKey = this.getSignupFormKey();
      const slots = this.querySelectorAll('[data-signup-form-slot]');
      let fallback = null;

      for (const slot of slots) {
        const key = slot.getAttribute('data-signup-form-slot');
        if (key === 'default') fallback = slot;
        if (key === formKey) return slot;
      }

      return fallback;
    }

    getActiveFormId() {
      return this.getActiveSlot()?.getAttribute('data-form-id') || '';
    }

    syncActiveForm() {
      const activeSlot = this.getActiveSlot();

      this.querySelectorAll('[data-signup-form-slot]').forEach((slot) => {
        slot.hidden = slot !== activeSlot;
      });

      this.dataset.activeFormKey = activeSlot?.getAttribute('data-signup-form-slot') || 'default';
      this.dataset.formId = this.getActiveFormId();
    }

    watchKlaviyoForm() {
      const signup = this.querySelector('[data-signup-signup]');
      if (!signup) return;

      const syncLoading = () => {
        const activeSlot = this.querySelector('[data-signup-form-slot]:not([hidden])');
        const formRoot = activeSlot?.querySelector('[data-signup-klaviyo-form]');
        if (!formRoot) return;

        const hasForm = formRoot.childElementCount > 0 || formRoot.textContent.trim().length > 0;
        if (hasForm) signup.removeAttribute('data-loading');
        else signup.setAttribute('data-loading', '');
      };

      syncLoading();
      this.formObserver = new MutationObserver(syncLoading);
      this.formObserver.observe(signup, { childList: true, subtree: true, characterData: true });
    }

    getDialog() {
      return this.querySelector('dialog[ref="dialog"]');
    }

    releaseScrollLock() {
      const body = document.body;
      if (body.style.position !== 'fixed') return;

      const top = parseInt(body.style.top, 10) || 0;
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      document.documentElement.removeAttribute('scroll-lock');
      window.scrollTo(0, -top);
    }

    // Close the modal dialog properly before hiding its parent.
    // Hiding the CTA while the dialog is still open leaves the page inert
    // (top layer + backdrop + scroll-lock), so no clicks work.
    closeSignupDialog() {
      const dialog = this.getDialog();
      if (!dialog || !dialog.open) return Promise.resolve();

      if (this.closingPromise) return this.closingPromise;

      this.closingPromise = new Promise((resolve) => {
        let done = false;

        const finish = () => {
          if (done) return;
          done = true;

          if (dialog.open) dialog.close();
          dialog.classList.remove('dialog-closing');

          // Release the theme scroll lock if it was left on the body.
          if (!document.querySelector('dialog[open][scroll-lock]')) {
            this.releaseScrollLock();
          }

          this.closingPromise = null;
          resolve();
        };

        dialog.addEventListener('close', finish, { once: true });

        const component = dialog.closest('dialog-component');

        try {
          if (typeof component?.closeDialog === 'function') {
            component.closeDialog();
          } else {
            dialog.close();
          }
        } catch (error) {
          finish();
        }

        setTimeout(finish, SIGNUP_DIALOG_CLOSE_TIMEOUT_MS);
      });

      return this.closingPromise;
    }

    handleKlaviyoForm(event) {
      const { type, formId } = event.detail || {};
      if (formId !== this.getActiveFormId()) return;

      if (type === 'embedOpen' || type === 'open') {
        this.querySelector('[data-signup-signup]')?.removeAttribute('data-loading');
      }

      if (type !== 'submit') return;

      this.markSubscribed(event.detail.metaData?.$email);

      // Give the Klaviyo success message a moment, then close and switch to purchase.
      const delay = parseInt(this.dataset.successDelay, 10);
      clearTimeout(this.successTimer);
      this.successTimer = setTimeout(
        () => {
          this.closeSignupDialog().then(() => this.render());
        },
        Number.isFinite(delay) && delay >= 0 ? delay : 1500
      );
    }

    render() {
      const showPurchase = this.canPurchase(this.dataset.phase);
      const cta = this.querySelector('[data-signup-cta]');
      const purchase = this.querySelector('[data-signup-purchase]');
      const dialog = this.getDialog();

      this.syncActiveForm();

      // Never hide the CTA while its modal dialog is still open.
      if (showPurchase && dialog?.open) {
        this.closeSignupDialog().then(() => this.render());
        return;
      }

      if (cta) cta.hidden = showPurchase;
      if (purchase) purchase.hidden = !showPurchase;

      this.dataset.accessState = showPurchase ? 'purchase' : 'signup';
    }
  }

  if (!customElements.get('signup-early-access')) {
    customElements.define('signup-early-access', SignupEarlyAccess);
  }
  } catch(e) { console.error(e); }
})();

})();
